import { webMediaRecorder, webAudioChunks, webAudioStream } from './start-web-recording.js';

/**
 * Stop web recording and return audio data
 * @returns {Promise<Object>} Recording data with base64 audio
 */
export const stopWebRecording = async () => {
  return new Promise((resolve, reject) => {
    if (!webMediaRecorder) {
      reject(new Error('No web recording in progress'));
      return;
    }

    webMediaRecorder.onstop = async () => {
      try {
        const audioBlob = new Blob(webAudioChunks, { type: 'audio/webm' });

        // Convert to base64
        const reader = new FileReader();
        reader.onload = () => {
          const base64 = reader.result.split(',')[1];
          resolve({
            value: {
              recordDataBase64: base64,
              msDuration: 0, // You might want to track this
              mimeType: 'audio/webm'
            }
          });
        };
        reader.readAsDataURL(audioBlob);
      } catch (error) {
        reject(error);
      }
    };

    webMediaRecorder.stop();

    // Stop all tracks
    if (webAudioStream) {
      webAudioStream.getTracks().forEach(track => track.stop());
    }
  });
};
